import { emptyString, globalSystemConstants } from "../../constants";
import { globalConstants } from "../../constants/global.constants";

function request(data, type, component = emptyString) {
  return {
    type:
      (component ? `${component}_` : emptyString) +
      type +
      globalConstants.REQUEST,
    data,
  };
}

function success(data, type, component = emptyString) {
  return {
    type:
      (component ? `${component}_` : emptyString) +
      type +
      globalConstants.SUCCESS,
    data,
  };
}

function failure(data, type, component = emptyString) {
  return {
    type:
      (component ? `${component}_` : emptyString) +
      type +
      globalConstants.FAILURE,
    data,
  };
}

function custom(data, type, component = emptyString) {
  return { type: (component ? `${component}_` : emptyString) + type, data };
}

// Show loading until the request finishes, even if it fails.
const withSpinner = async (dispatch, actionType, executeRequest) => {
  dispatch(custom(actionType, globalSystemConstants.SPINNER_ACTIVATE));
  try {
    return await executeRequest();
  } finally {
    dispatch(custom(actionType, globalSystemConstants.SPINNER_DIACTIVATE));
  }
};

export { request, success, failure, custom, withSpinner };
